<div class="thread-filters-wrapper">
    <div class="thread-filters thread-filters--full-version">
        <span class="me-3" translate>In this post we found:</span>

        @for (filter of threadFilters; track filter; let last = $last) {
            <button
                class="btn-sm filter-button form-control me-2 mt-1 mb-1"
                [ngClass]="{ 'active-filter': threadFilterService.activeThreadFilter === filter, 'me-4': last }"
                (click)="toggleFilter(filter)"
                [tooltip]="filter.tooltipText ? filter.tooltipText : ''"
                container="body"
                delay="500">
                {{ filter.name }}
                ({{ filter.count }})
            </button>
        }

        <ng-container *ngTemplateOutlet="searchFilter"></ng-container>
    </div>
    <div class="thread-filters thread-filters--minimized-version">
        <div dropdown class="position-relative link-dropdown me-1" placement="bottom">
            <a
                href
                dropdownToggle
                (click)="(false)"
                class="basic-link-dropdown text-light"
                aria-controls="basic-link-dropdown">
                <sb-inline-svg
                    class="icon me-1"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Filter icon.svg'"></sb-inline-svg>
                <span translate>Filter</span>
                <span class="add-arrow"></span>
            </a>
            <ul *dropdownMenu class="dropdown-menu search-thread-dropdown" role="menu">
                @for (filter of threadFilters; track filter) {
                    <li role="menuitem">
                        <div
                            class="dropdown-item"
                            (click)="toggleFilter(filter)"
                            [ngClass]="{ disabled: threadFilterService.activeThreadFilter === filter }">
                            {{ filter.name }} ({{ filter.count }})
                        </div>
                    </li>
                }
            </ul>
        </div>

        @if (threadFilterService.activeThreadFilter) {
            <span class="label label-sm active-filter me-3">
                {{ threadFilterService.activeThreadFilter.name }} ({{ threadFilterService.activeThreadFilter.count }})
                <sb-inline-svg
                    class="icon icon-close pointer"
                    (click)="removeFilter()"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
                </sb-inline-svg>
            </span>
        }

        <ng-container *ngTemplateOutlet="searchFilter"></ng-container>
    </div>

    <ng-template #searchFilter>
        <div class="search-filter-wrapper">
            <sb-inline-svg
                class="icon search-icon"
                (click)="searchInput.focus()"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Search icon.svg'"></sb-inline-svg>
            <input
                class="form-control search-filter"
                #searchInput
                type="search"
                placeholder="{{ 'Search post' | translate }}"
                aria-label="Search"
                [(ngModel)]="threadFilterService.searchQuery"
                (ngModelChange)="searchQueryUpdate.next($event)"
                name="search"
                autocomplete="off" />
            @if (threadFilterService.searchQuery) {
                <button class="btn-transparent btn-clear" (click)="cleanSearch()">
                    <sb-inline-svg
                        class="icon icon-clear"
                        aria-label="Clean search"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
                    </sb-inline-svg>
                </button>
            }
        </div>
    </ng-template>
</div>
